import {AuthModel, UserModel} from './_models'
import {Role} from '../../../types/domain'
import {api, setToken, clearToken, AuthUser} from '../../../services/api'

// Map the backend SafeUser onto the Metronic UserModel the UI expects.
function toUserModel(u: AuthUser): UserModel {
  return {
    id: 1,
    username: u.email,
    password: undefined,
    email: u.email,
    first_name: u.firstName,
    last_name: u.lastName,
    role: u.role === 'ADMIN' ? 'admin' : 'user',
    appRole:
      u.role === 'ADMIN'
        ? Role.ADMIN
        : u.role === 'CLEANER'
        ? Role.CLEANER
        : Role.RENTER,
  }
}

function persist(u: AuthUser) {
  localStorage.setItem('crashpad_user', JSON.stringify(toUserModel(u)))
}

export async function login(email: string, password: string): Promise<{data: AuthModel}> {
  const res = await api.login(email, password)
  setToken(res.accessToken)
  persist(res.user)
  return {data: {api_token: res.accessToken}}
}

export async function registerRenter(data: {
  email: string
  password: string
  firstName: string
  lastName: string
}): Promise<{data: AuthModel; user: UserModel}> {
  const res = await api.register(data)
  setToken(res.accessToken)
  persist(res.user)
  return {data: {api_token: res.accessToken}, user: toUserModel(res.user)}
}

// Validate the session server-side via /auth/me and refresh the cached user.
export async function getUserByToken(_token: string): Promise<{data: UserModel}> {
  const me = await api.getMe()
  persist(me)
  return {data: toUserModel(me)}
}

export function requestPassword(email: string): Promise<{data: {result: boolean}}> {
  return Promise.resolve({data: {result: email.includes('@')}})
}

export function adminLogout() {
  clearToken()
  localStorage.removeItem('crashpad_user')
  localStorage.removeItem('admin_user')
}
